<template>
  <div class="modal fade" :id="'SharedListingModal_'+_uid" tabindex="-1" role="dialog" aria-hidden="true"
       data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content" style="z-index: -10000 !important;">
        <div class="modal-header">
          <h5 class="modal-title">Share <small>{{ title }}</small></h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" :id="`share_modal_body_${_uid}`">
          <div class="d-flex justify-content-center">
            <a :href="mail_url" class="btn btn-dark ml-1" data-toggle="tooltip" title="EMAIL"><i
                class="far fa-envelope"></i></a>
            <a :href="sms_url" class="btn btn-secondary ml-1" data-toggle="tooltip" title="SMS" v-if="is_mobile"><i
                class="fas fa-sms"></i></a>
            <button class="btn btn-primary ml-1" data-toggle="tooltip" type="button"
                    @click.prevent="share_internal_sms()" title="INTERNAL SMS"><i class="far fa-comment"></i></button>
<!--            <a :href="whatsapp_url" class="btn btn-success ml-1" data-toggle="tooltip" title="WHATSAPP"><i
                class="fab fa-whatsapp"></i></a>-->
            <strong class="shared_social_separator ml-1"> | </strong>
<!--            <button @click.prevent="share_facebook()" type="button" class="btn btn-primary ml-1" data-toggle="tooltip"
                    title="FACEBOOK"><i class="fab fa-facebook-f"></i></button>
            <button @click.prevent="share_twiter()" type="button" class="btn btn-info ml-1" data-toggle="tooltip"
                    title="TWITTER"><i class="fab fa-twitter"></i></button>
            <button @click.prevent="share_pinterest()" type="button" class="btn btn-danger ml-1" data-toggle="tooltip"
                    title="PINTEREST"><i class="fab fa-pinterest-p"></i></button>-->
            <button @click.prevent="copy_url()" type="button" class="btn btn-secondary ml-1" data-toggle="tooltip"
                    title="Click to Copy Link"><i class="fas fa-link"></i></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'share-modal',
  props: {
    title: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    shareFacebook: {
      type: Object,
      default: () => {
        return {
          'title': null,
          'image': null,
          'description': null
        }
      }
    },
    shareLink: {
      type: String,
      required: true
    }
  },
  mounted() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.is_mobile = true;
    } else {
      this.is_mobile = false;
    }
  },
  computed: {
    sms_url() {
      return `sms:;?&body=${encodeURIComponent(this.shareLink)}`;
    },
    whatsapp_url() {
      return `https://api.whatsapp.com/send?text=${encodeURIComponent(this.shareLink)}`;
    },
    mail_url() {
      return `mailto:?to=&body=${encodeURIComponent(this.shareLink)}`
    }
  },
  methods: {
    share_internal_sms() {
      this.copy_url();
      this.close();
      setTimeout(() => {
        //this.$router.push('/sms');
        window.location.href = "/sms";
      }, 300);
    },
    share_facebook() {
      let title = this.shareFacebook.title || this.title || '';
      let descr = this.shareFacebook.description || '';
      let url = this.shareLink;
      let image = this.shareFacebook.image || '';
      window.open('http://www.facebook.com/sharer.php?s=100&p[title]=' + title + '&p[summary]=' + descr + '&p[url]=' + url + '&p[images][0]=' + image, 'shre', "width=600, height=400, scrollbars=no")
    },
    share_twiter() {
      window.open('https://twitter.com/share?url=' + this.shareLink, 'twitter-popup', 'height=400,width=600,scrollbars=no');
    },
    share_pinterest() {
      window.open('http://pinterest.com/pin/create/button/?' + this.shareLink, '_blank');
    },
    copy_url() {
      if (window.clipboardData && window.clipboardData.setData) {
        return clipboardData.setData("Text", this.shareLink);
      } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
        let body = document.getElementById(`share_modal_body_${this._uid}`);
        var input = document.createElement("input");

        input.value = `${this.name ? '"' + this.name + '" ' : ''}${this.shareLink}`;

        input.style.position = "fixed";  // Prevent scrolling to bottom of page.
        body.appendChild(input);
        input.select();
        try {
          document.execCommand("copy");  // Security exception may be thrown by some browsers.
        } catch (ex) {
          console.warn("Copy to clipboard failed.", ex);
        } finally {
          body.removeChild(input);
        }
      } else {
        console.warn("Copy to clipboard failed. Not function valid");
      }
      this.close();
    },
    open() {
      //this.copy_url();
      $('#SharedListingModal_' + this._uid).modal('show');
    },
    close() {
      this.$emit('onClose');
      $('#SharedListingModal_' + this._uid).modal('hide');
    }
  },
  data() {
    return {
      is_mobile: false
    }
  }
}
</script>
